import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuInfo } from 'src/app/models/menu-info';
import { AuthServiceService } from 'src/services/auth-service.service';
import { ConfigService } from 'src/services/config.service';
import { ConfigurationService } from 'src/services/configuration.service';
import { HttpClientWrapperService } from 'src/services/http-client-wrapper.service';
import { MenuService } from 'src/services/menu-service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  mobileMenu = false;

  menuList: MenuInfo[] = [];
  displayMenuList = []

  listen: boolean = false;

  error: any

  adminMenu: any = []
  adminData
  adminId

  clientInfo: string

  constructor(private router: Router,
    private http: HttpClientWrapperService,
    private config: ConfigService,
    private configurationService: ConfigurationService,
    private auth: AuthServiceService) { }

  ngOnInit(): void {
    this.adminMenu = JSON.parse(localStorage.getItem('adminGroupInfo'));
    this.adminId = localStorage.getItem('id');
    this.getProfile(this.adminId);
    this.getMenus();
    this.clientInfo = this.configurationService.getClientInfo();
  }

  getProfile(id): void {
    const url = this.config.json.apiEndpoint + 'admin/getAdminInfoById/' + id;
    this.http.get(url).subscribe(
      (data) => {
        this.adminData = data.data;
      }
    )
    // //console.log(this.adminData)
    // this.profile = this.auth.getProfile();
    // //console.log(this.profile);
  }


  getMenuInfo() {
    this.adminMenu.forEach(group => {

      group.adminGroupAccessControlList.forEach(accessItem => {

        // find matching menu by ID
        const menu = this.menuList.find(m => m.id === accessItem.id);

        if (!menu) return;

        // set checked / indeterminate
        menu.checked = accessItem.checked;
        menu.indeterminate = accessItem.indeterminate;

        // handle submenu
        if (accessItem.subMenu?.length > 0) {
          accessItem.subMenu.forEach((sub, index) => {
            const subMenu = menu.subMenu.find(s => s.id === sub.id);
            if (subMenu) {
              subMenu.checked = sub.checked;
            }
          });
        }

      });

    });

    this.auth.menuInfo = this.menuList;
    localStorage.setItem('menuInfo', JSON.stringify(this.menuList));

    this.getDisplayMenus();
  }


  logout() {
    localStorage.removeItem('token');
    localStorage.clear()
    localStorage.setItem('guardFlag', "true")
    this.router.navigateByUrl('login');
  }


  openMenu(): void {
    this.mobileMenu = !this.mobileMenu;
    // //console.log(this.mobileMenu)
    if (this.mobileMenu) {
      document.querySelector<HTMLElement>(".main__menu").style.display = "flex";
    }
    else {
      document.querySelector<HTMLElement>(".main__menu").style.display = "none";
    }
  }

  subMenuOpen(e): void {
    let el = e.target.closest('li') as HTMLElement;
    let ifPresent = el?.classList.contains("active");
    if (el) {
      let element = document.querySelectorAll<HTMLElement>(".mm");
      Array.prototype.forEach.call(element, function (node) {
        node.classList.remove("active");
      });
      if (!ifPresent) {
        el.classList.add("active");
        this.listen = true;
      }
    }
  }

  clickOutside(event): void {
    let element = document.querySelectorAll<HTMLElement>(".mm");
    Array.prototype.forEach.call(element, function (node) {
      node.classList.remove("active");
    });
    this.listen = false;
  }

  getMenus(): void {
    // const url = "http://192.168.10.23:8070/menu/getMenuInfoList";
    const url = this.config.json.apiEndpoint + 'menu/getMenuInfoList';
    let adminMenuList: MenuInfo[] = [];
    this.http.get(url).subscribe(
      (res) => {
        // //console.log(res);
        adminMenuList = res.data;
        this.menuList = adminMenuList;
        this.menuList.forEach(item => {
          delete item['createdDate']
          if (item.subMenu.length > 0) {
            for (let submenu of item.subMenu) {
              delete submenu['createdDate']
            }
          }
        })
        // //console.log(this.menuList)
        this.getMenuInfo();
        // this.menuList = this.menuService.getValidMenuList(adminMenuList, true, false);
      },
      (err) => {
        this.error = err;
        // //console.log(err);
      }
    )
  }

  menuRouter(menus) {
    if (menus.subMenu.length == 0) {
      this.router.navigateByUrl(menus.menuUrl);
    }
  }

  getDisplayMenus() {
    for (let menu of this.menuList) {
      if (menu.checked || menu.indeterminate) {
        this.displayMenuList.push(menu)
      }
    }
  }

  gotoProfile() {
    // this.router.navigate(['/profile']);
    this.router.navigateByUrl('profile');
  }

}
